function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGpayBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 25,
  viewBox: "0 0 35 25"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 23.18,
  x: 0.5,
  y: 0.5,
  rx: 3.5,
  ry: 3.5,
  style: {
    fill: "#fff",
    stroke: "#d9d9d9"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.53 15.88v-3.04h1.56c.64 0 1.18-.22 1.62-.64l.11-.11c.8-.88.75-2.25-.11-3.07-.43-.43-1.01-.67-1.62-.65h-2.5v7.51zm0-3.97V9.29h1.58c.34 0 .66.13.9.37.51.5.52 1.34.03 1.86-.24.26-.58.4-.93.39zm7.68-.77c-.4-.38-.96-.57-1.65-.57-.9 0-1.57.34-2.02 1l.83.53c.3-.46.72-.68 1.25-.68.33 0 .66.13.91.35s.39.53.39.86v.22c-.36-.2-.82-.31-1.38-.31-.66 0-1.18.16-1.58.47-.39.32-.59.74-.59 1.27-.01.49.19.95.56 1.26.37.34.84.5 1.39.5.65 0 1.17-.29 1.56-.88h.04v.71h.9V12.7c0-.67-.2-1.19-.6-1.57Zm-2.56 3.79a.79.79 0 0 1-.31-.63c0-.28.13-.52.38-.7.26-.19.58-.28.96-.28.53 0 .94.11 1.23.35 0 .41-.16.76-.47 1.06-.28.29-.66.45-1.06.45-.26 0-.52-.08-.73-.25m5.19 3.21 3.15-7.4h-1.03l-1.46 3.69h-.02l-1.49-3.69h-1.03l2.07 4.81-1.17 2.59h.97Z",
  style: {
    fill: "#3c4043",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.27 12.18c0-.29-.02-.59-.07-.87H9.22v1.66h2.28c-.09.53-.4 1.01-.84 1.31v1.08h1.36c.8-.75 1.25-1.86 1.25-3.18",
  style: {
    fill: "#4285f4"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.22 16.39c1.14 0 2.1-.38 2.8-1.04l-1.36-1.08c-.38.26-.87.41-1.44.41-1.1 0-2.03-.76-2.37-1.78h-1.4v1.11c.72 1.46 2.17 2.37 3.77 2.37Z",
  style: {
    fill: "#34a853"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.85 12.91c-.18-.53-.18-1.11 0-1.65v-1.11h-1.4c-.6 1.22-.6 2.65 0 3.87z",
  style: {
    fill: "#fbbc04"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.22 9.47c.6-.01 1.18.22 1.62.65l1.21-1.23a4.05 4.05 0 0 0-2.83-1.12c-1.59 0-3.05.92-3.77 2.38l1.4 1.11c.33-1.02 1.27-1.79 2.37-1.79",
  style: {
    fill: "#ea4335"
  }
}));
export default SvgGpayBox;